import type { MutationObserverOptions } from '@tanstack/vue-query';
import { useMutation } from '@tanstack/vue-query';
import { MyDocumentsService } from '../service/my-documents.service';

export const useMyDocumentsCreateEmail = (
  options?: MutationObserverOptions<boolean, unknown, unknown, unknown>
) =>
  useMutation({
    ...options,
    mutationFn: () => MyDocumentsService.createEmailVerification(),
    onSuccess: (data, variables, context) => {
      if (options?.onSuccess) {
        options?.onSuccess(data, variables, context);
      }
    },
  });
